import { login, useAuth } from '@pesto/features';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { routes } from '../constants/routes';

interface ProtectedRouteProps {
  isAuthenticated: boolean;
  redirectPath?: string;
}

export const ProtectedRoute = (props: ProtectedRouteProps) => {
  const { redirectPath = routes.login } = props;
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated()) {
    login.rememberPostLoginRedirect(`${location.pathname}${location.search}${location.hash}`);

    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};
